/**
 * The console's copy of `priceShortened` in utils/shortLinks.js, and it must
 * agree with it: the builder counts a text's segments as the operator types,
 * and with click tracking on, what goes out has every link replaced by
 * `<base>/<7-character code>`. Counting the long URLs instead would quote a
 * two-segment text that is actually sent as one — or, near the limit, refuse
 * nothing the server will then refuse. `shortLinks.test.ts` and
 * scripts/verify/shortlinks.js pin the same cases.
 */
export const SHORT_CODE_LENGTH = 7;
const URL_IN_TEXT_RE = /https?:\/\/[^\s<>"'()[\]{}]+/gi;

export function priceShortened(text: string, base: string): string {
  const placeholder = 'x'.repeat(SHORT_CODE_LENGTH);
  return String(text || '').replace(URL_IN_TEXT_RE, (match) => {
    const trail = match.match(/[.,;:!?]+$/)?.[0] ?? '';
    const url = trail ? match.slice(0, -trail.length) : match;
    if (url.startsWith(`${base}/`)) return match;
    return `${base}/${placeholder}${trail}`;
  });
}
